<template>
	<!-- 优惠管理-->
	<div class="public_Spacing systemCorporateAccount">
		<div class="pulbic_oparetionBlock">
			<div class="public_criteriaRange customerManagementPC-select">
				<!-- <div class="public_oparetionBlock_Menu">
					<label class="public_lbSty">优惠类型：</label>
					<el-select class="public_optionSty dropDown_Define" v-model="perTypeValue" filterable>
						<el-option v-for="item in options" :key="item.SETTB206CA00" :label="item.SETTB206CA01" :value="item.SETTB206CA00"></el-option>
					</el-select>
				</div>
				<div class="public_oparetionBlock_Menu">
					<label class="public_lbSty">状态：</label>
					<el-select class="public_optionSty dropDown_Define" v-model="typevalue" filterable>
						<el-option v-for="item in optionsType" :key="item.value" :label="item.label" :value="item.value"></el-option>
					</el-select>
				</div> -->
				
				<div class="public_oparetionBlock_Menu">
					<label class="public_lbSty">客户名称：</label>
					<div class="el-select public_optionSty">
						<div class="el-input el-input--suffix">
							<input style="padding-right: 10px;" maxlength="7"
								class="el-input__inner pulic_carNumber" type="text" placeholder="请输入客户名称"
								v-model="cusQueryName" />
						</div>
					</div>
				</div>
				<div class="public_oparetionBlock_Menu">
					<label class="public_lbSty">手机号：</label>
					<div class="el-select public_optionSty">
						<div class="el-input el-input--suffix">
							<input maxlength="11" class="el-input__inner pulic_carNumber" type="text"
								placeholder="请输入手机号" v-model="cusQueryiphone" />
						</div>
					</div>
				</div>
				<div class="public_oparetionBlock_Menu">
					<label class="public_lbSty">客户等级：</label>
					<el-select class="public_optionSty dropDown_Define" v-model="khdj" @clear="clearFun" clearable placeholder="请选择">
						<el-option v-for="item in khdjOperation" :key="item.SETTB206CA00" :label="item.SETTB206CA01"
							:value="item.SETTB206CA00">
						</el-option>
					</el-select>
				</div>
				
			</div>
			<div class="public_operatArea" style="margin-left: 0;">
				<div class="public_operatBtn" style="margin-left: 0;">
					<el-button class="public_saleWater_chaxun"  type="primary" @click="queryPreTypeLsit()" v-shiroHiden="solelist" id="查询" >
						<i class="iconfont icon-chaxun"></i>查询
					</el-button>
				</div>
			</div>
		</div>

		<div class="pulbic_oparetionBlock pulbic_table_container">
			<el-table :data="tableData" style="width: 100%" stripe max-height="90%" class="public_tableColumn"
			 :header-cell-style="{color:'rgba(51,51,51,1)','font-weight':'bold'}">
			 <el-table-column v-if="uobj.pertb005.pertb005cb00=='CUS-1'" align="center" prop="ORMTB410CA00" label="客户名称">
				 <template slot-scope="scope">
				 	<p>
				 		<span>{{scope.row.ORMTB410CA00}}</span>
				 	</p>
				 	<p style="color: #999;">
				 		<span>{{scope.row.ORMTB410CA02}}</span>
				 	</p>
				 
				 </template>
			 </el-table-column>
			 <el-table-column v-if="uobj.pertb005.pertb005cb00=='CUS-1'" align="center" prop="ORMTB410CA06Name" label="客户等级"></el-table-column>
				<el-table-column align="center" prop="ORMTB410CB16Name" label="优惠类型"></el-table-column>
				<el-table-column align="center" label="状态">
					<template slot-scope="scope" >
						<el-switch @change="changeTable(scope.row)" :width="switchWidth" inactive-color="rgba(255, 90, 69, 1)"
						 active-value="0" v-model="scope.row.ORMTB410CB16" inactive-value="1"></el-switch>
					</template>
				</el-table-column>
				<el-table-column label="操作" width="150">
					<template slot-scope="scope" >
						<div style="text-align: center;">
							<el-button class="public_icon_qiyong public_icon_width public_icon_margin" type="info" v-if="scope.row.ORMTB410CB16==0"
							 size="small" @click="tableDetilsClick(scope.row),upPerObj=scope.row" >
								详情
							</el-button>
						</div>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div class="public-dialog">
			<el-dialog title="详情" :visible.sync="PreferentialDetilsShow" @close="upPerObj=''" width="50%" :closeOnClickModal='false'>
				<div id="" style="margin-bottom: 20px;">
					<el-button class="public_saleWater_chaxun" type="primary" @click="insertShow=true" id="新增" >						<i class="iconfont icon-tianjia1"></i>新增					</el-button>
				</div>
				<div class="pulbic_oparetionBlock pulbic_table_container">
					<el-table :data="PreferentialDetilsData" style="width: 100%" stripe max-height="90%" class="public_tableColumn"
					 :header-cell-style="{color:'rgba(51,51,51,1)','font-weight':'bold'}">
						<el-table-column align="center" prop="money" label="价格区间"></el-table-column>
						<el-table-column align="center"  label="状态">
							<template slot-scope="scope" >
								<el-switch @change="Prechange(scope.row)" inactive-color="rgba(255, 90, 69, 1)" v-model="scope.row.SETTB400CA07"
								 active-value="1" :width="switchWidth" inactive-value="0"></el-switch>
							</template>
						</el-table-column>
						<el-table-column label="操作" width="150">
							<template slot-scope="scope" >
								<div style="text-align: center;">
									<el-button class="public_icon_qiyong public_icon_width public_icon_margin" type="info" v-if=""
									 size="small" @click="undateClick(scope.row)" >
										修改
									</el-button>
									<el-button class="public_icon_qiyong public_icon_width public_icon_margin" type="info" v-if=""
									 size="small" @click="erpPreferentialShow=true,erpreducedObj=scope.row,erpPreferentialQuery(),currentPage=1" >
										厂区设置
									</el-button>
								</div>
							</template>
						</el-table-column>
					</el-table>
				</div>
			</el-dialog>
		</div>
		<div class="public-dialog">
			<el-dialog title="详情" :visible.sync="levelmangShow" @close="upPerObj=''" width="60%" :closeOnClickModal='false'>
				<div class="levelmang-title">
					<div class="levelmang-title-active">厂区设置</div>
					<div >级别设置</div>
				</div>
				<div class="public_criteriaRange">
					<div class="public_oparetionBlock_Menu" >
						<label class="public_lbSty">企业：</label>
						<el-select class="public_optionSty dropDown_Define" v-model="enterpriseTwo" placeholder="请选择" >
							<el-option v-for="item in enterpriseTwoOptionList" :key="item.SETTB99ID" :label="item.SETTB99CA00" :value="item.SETTB99ID">
							</el-option>
						</el-select>
					</div>
					<el-button class="public_saleWater_chaxun" type="primary" id="查询" @click="queryGradePreLsit()">查询</el-button>
				</div>
				<ul class="levelmang-table">
					<li class="levelmang-table-head">
						<div class="levelmang-table-CQ">
							厂区名称
						</div>
						<div class="levelmang-table-JB">
							级别
						</div>
						<div class="levelmang-table-KJ">
							单价扣减
						</div>
						<div class="levelmang-table-ZK">
							整车折扣
						</div>
						<div class="levelmang-table-YH">
							整车优惠
						</div>
					</li>
					<li class="levelmang-table-li" v-for="(item,index) in tableDataGradePre" :key="index">
						<div class="levelmang-table-CQ levelmang-table-CQ-list" v-if="item.settb500List.length>0">
							<div>{{item.SETTB100CA00}}</div>
						</div>
						<div class="levelmang-table-li-tab" v-if="item.settb500List.length>0">
							<div class="levelmang-table-li-tab-li" v-for="(items,indexs) in item.settb500List" :key="indexs">
								<div class="levelmang-table-JB">
									{{items.SETTB500CAName}}
								</div>
								<div class="levelmang-table-KJ public-chech-details">
									<el-input-number :precision="2"
									 :step="1" :min="0" :max="100" v-model="items.djkj"></el-input-number>元
								</div>
								<div class="levelmang-table-ZK">
									<input type="text"  v-model="items.zczk" />%
								</div>
								<div class="levelmang-table-YH">
									<input type="text" v-model="items.zcyh"/>元
								</div>
							</div>
						</div>
					</li>
					<!-- <li class="levelmang-table-li">
							<div class="levelmang-table-CQ">
								<div>厂区名称</div>
							</div>
						<div class="levelmang-table-li-tab" >
							<div class="levelmang-table-li-tab-li">
								<div class="levelmang-table-JB">
									级别
								</div>
								<div class="levelmang-table-KJ public-chech-details">
									<el-input-number  :precision="2"
									 :step="1" :min="0" :max="100" ></el-input-number>元
								</div>
								<div class="levelmang-table-ZK">
									<input type="" name="" id="" value="" />%
								</div>
								<div class="levelmang-table-YH">
									<input type="" name="" id="" value="" />元
								</div>
							</div>
							<div class="levelmang-table-li-tab-li">
								<div class="levelmang-table-JB">
									级别
								</div>
								<div class="levelmang-table-KJ public-chech-details">
									<el-input-number  :precision="2"
									 :step="1" :min="0" :max="100" ></el-input-number>元
								</div>
								<div class="levelmang-table-ZK">
									<input type="" name="" id="" value="" />%
								</div>
								<div class="levelmang-table-YH">
									<input type="" name="" id="" value="" />元
								</div>
							</div>
						</div>
					</li> -->
				</ul>
				<div class="salesPreferentialDig-btn">
					<!-- @click="submissionGradePre" -->
					<el-button type="primary" @click="submisyhsionGradePre">提交</el-button>
					<el-button type="warning" @click="ResetGradePre">重置</el-button>
				</div>
			</el-dialog>
		</div>
		<!-- 新增 -->
		<div class="public-dialog">
			<el-dialog title="新增" :visible.sync="insertShow" width="40%" :closeOnClickModal='false' @close="insertStatMoney='',insertEndMoney='',erpreducedObj=''">
				<div class="salesPreferentialDig">
					<div class="salesPreferentialDig-li">
						<div class="salesPreferentialDig-li-text">
							设置价格区间
						</div>
						<div class="salesPreferentialDig-li-ipt">
							<input ref="insertStatMoney" type="text" v-model="insertStatMoney" @input="insertStatInpt"/>
							<div>
								<span></span>
							</div>
							<input ref="insertEndMoney" type="text" v-model="insertEndMoney" @input="insertEndInpt"/>
						</div>
					</div>
					<div class="salesPreferentialDig-btn">
						<el-button type="primary" @click="insertserve">保存</el-button>
						<el-button type="warning" @click="insertShow=false">取消</el-button>
					</div>
				</div>
			</el-dialog>
		</div>
		<div class="public-dialog">
			<el-dialog title="修改" :visible.sync="updateShow" @close="upMoneyObj='',updateStatMoney='',updateEndMoney=''" width="40%" :closeOnClickModal='false'>
				<div class="salesPreferentialDig">
					<div class="salesPreferentialDig-li">
						<div class="salesPreferentialDig-li-text">
							设置价格区间
						</div>
						<div class="salesPreferentialDig-li-ipt">
							<input ref="updateStatMoney" type="text" v-model="updateStatMoney" @input="updateStatInpt"/>
							<div>
								<span></span>
							</div>
							<input ref="updateEndMoney" type="text" v-model="updateEndMoney" @input="updateEndInpt"/>
						</div>
					</div>
					<div class="salesPreferentialDig-btn">
						<el-button type="primary" @click="updateServe">保存</el-button>
						<el-button type="warning" @click="updateShow=false">取消</el-button>
					</div>
				</div>
			</el-dialog>
		</div>
		<div class="public-dialog">
			<el-dialog title="厂区设置" @close="pageMo=1,limitMo=10" :visible.sync="erpPreferentialShow" width="60%" :closeOnClickModal='false'>
				<div id="">
					<div class="pulbic_oparetionBlock pulbic_table_container">
						<el-table :data="erpPreferentialData" style="width: 100%" stripe max-height="90%" class="public_tableColumn"
						 :header-cell-style="{color:'rgba(51,51,51,1)','font-weight':'bold'}">
							<el-table-column align="center" prop="SETTB99CA00" label="厂区名称"></el-table-column>
							<el-table-column align="center" prop="money" label="价格区间"></el-table-column>
							<el-table-column align="center"  label="优惠金额" width="200">
								<template slot-scope="scope" >
									<div class="public-chech-details">
										<el-input-number v-model="scope.row.SETTB401CA00" :precision="2" :step="1" :min="0"></el-input-number>
									</div>
								</template>
							</el-table-column>
						</el-table>
					</div>
					<div class="pulbic_pagesize">
						<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="currentPage"
						 :page-sizes="[10, 20, 30, 40]" :page-size="limitMo" layout="total,sizes, prev, pager, next" :total="pagingPageMo"></el-pagination>
					</div>
					<div class="salesPreferentialDig-btn">
						<el-button type="primary" @click="erpPreferentialServe">确定保存</el-button>
						<el-button type="warning" @click="erpPreferentialShow=false">取消</el-button>
					</div>
				</div>
			</el-dialog>
		</div>
		
		<div class="public-dialog">
			<el-dialog title="优惠信息" @close="pageMo=1,limitMo=10" :visible.sync="yhPreferentialShow" width="60%" :closeOnClickModal='false'>
				<div id="">
					<!-- <div class="pulbic_oparetionBlock pulbic_table_container">
						<el-table :data="erpPreferentialData" style="width: 100%" stripe max-height="90%" class="public_tableColumn"
						 :header-cell-style="{color:'rgba(51,51,51,1)','font-weight':'bold'}">
							<el-table-column align="center" prop="SETTB99CA00" label="厂区名称"></el-table-column>
							<el-table-column align="center" prop="SETTB99CA00" label="级别"></el-table-column>
							<el-table-column align="center" prop="money" label="优惠单价"></el-table-column>
							<el-table-column align="center" prop="money" label="整车折扣"></el-table-column>
							<el-table-column align="center" prop="money" label="整车优惠"></el-table-column>
							
						</el-table>
					</div> -->
					
					<ul class="levelmang-table">
						<li class="levelmang-table-head">
							<div class="levelmang-table-CQ">
								厂区名称
							</div>
							<div class="levelmang-table-JB">
								级别
							</div>
							<div class="levelmang-table-KJ">
								优惠单价
							</div>
							<div class="levelmang-table-ZK">
								整车折扣
							</div>
							<div class="levelmang-table-YH">
								整车优惠
							</div>
						</li>
						<li class="levelmang-table-li" v-for="(item,index) in tableDatayhGradePre" :key="index">
							<div class="levelmang-table-CQ levelmang-table-CQ-list">
								<div>{{item.name}}</div>
							</div>
							<div class="levelmang-table-li-tab" >
								 <!-- v-for="(items,indexs) in tableDatayhGradePre" :key="indexs" -->
								<div class="levelmang-table-li-tab-li">
									<div class="levelmang-table-JB">
										{{item.SETTB500CAName}}
									</div>
									<div class="levelmang-table-KJ public-chech-details">
										<div>{{item.djkj}}</div>
										
									</div>
									<div class="levelmang-table-ZK">
										<div>{{item.zczk}}%</div>
									</div>
									<div class="levelmang-table-YH">
										<div>{{item.zcyh}}元</div>
									</div>
								</div>
							</div>
						</li>
					</ul>
					
					<div class="salesPreferentialDig-btn">
						<el-button type="primary" @click="submissionGradePre">确定保存</el-button>
						<el-button type="warning" @click="yhPreferentialShow=false">取消</el-button>
					</div>
				</div>
			</el-dialog>
		</div>	
			<div class="pulbic_pagesize">
				<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
					:current-page.sync="pageMo" :page-sizes="[10, 20, 30, 40]" :page-size="limitMo"
					layout="total, sizes, prev, pager, next" :total="recordCount">
				</el-pagination>
			</div>
	</div>
</template>

<script>
	
	export default {
		data() {
			return {
				uobj: this.$store.state.uobj, //登陆缓存--用户信息
				perTypeValue:'',
				switchWidth:30,
				options:[],
				typevalue:'',
				optionsType:[
					{
						value:'',
						label:'全部',
					},
					{
						value:1,
						label:'启用',
					},
					{
						value:0,
						label:'禁用',
					}
				],
				erpreducedObj:'',
				upPerObj:'',
				khdjOperation: [],
				khdj: '全部',
				cusQueryName: '',
				cusQueryiphone: '',
				insertStatMoney:0,
				insertEndMoney:0,
				updateStatMoney:0,
				updateEndMoney:0,
				insertShow:false,
				updateShow:false,
				PreferentialDetilsShow:false,
				erpPreferentialShow:false,
				yhPreferentialShow:false,
				tableData: [], //列表table数据--查询
				erpPreferentialData:[],
				PreferentialDetilsData:[],
				upMoneyObj:{},
				pageMo: 1, //默认列表页码
				limitMo: 10, //每页的条数
				pagingPageMo: 0, //分页--数据列表共有的条数
				currentPage: 1, //设置当前页默认为1
				recordCount:1,
				solelist: [],
				// 
				levelmangShow:false,
				tableDataGradePre:[],
				tableDatayhGradePre:[],
				tableDataGradePreOld:[],
				enterpriseTwo:'',
				enterpriseTwoOptionList:[],
				objyh:{},
				// 历史缓存
				currentUrl: this.$route.path,
				historyInfo: "",
			};
		},
		created() {
			var list = "";
			list = this.$store.state.solelist;
			var path = this.$route.path;
			if (path === "/SalesystemCorporateAccount") {
				path = "/Home" + path;
			}
			this.solelist = this.$baseAPI.querSoleList(list, path); //获取权限列表
			this.uobj = this.$store.state.uobj;
			// console.log(this.uobj)
			// 赋值，缓存销毁
			this.historyInfo = JSON.parse(sessionStorage.getItem(this.currentUrl));
			sessionStorage.removeItem(this.currentUrl);
			if (this.historyInfo != null && this.historyInfo != "") {
				this.init();
			}
		},
		mounted() {
			this.queryPreTypeLsit()
			this.khdjFun()
			// this.querySelectPreTypeLsit()
		},
		// 存储数据
		beforeDestroy() {
			var obj = {
				perTypeValue: this.perTypeValue, //
				typevalue: this.typevalue, //
			};
			sessionStorage.setItem(this.currentUrl, JSON.stringify(obj));
		},
		methods: {
			init() {
				this.perTypeValue = this.historyInfo.perTypeValue;
				this.typevalue = this.historyInfo.typevalue;
			},
			khdjFun(){
				this.khdjOperation =[]
				var List = [{
					SETTB206CA00: '',
					SETTB206CA01: '全部',
				}];
				var url="/set/settb500/selectLevel"
				// console.log(this.uobj)
				var postData = {
					// ORMTB400ID: this.uobj.ormtb400.ORMTB400ID, //一级代码ID
					// ORMTB400CA03: this.uobj.ormtb400.ORMTB400CA03, //一级客户代码
					// ORMTB410ID:this.objyh.ORMTB410ID,
					// SETTB99ID:this.enterpriseTwo//二级企业ID
				}
				
				var loading=this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				this.axios.post(url, postData).then(res => {
					console.log(res)
					if (res.data.code == 200) {
						var data = res.data.data
						this.khdjOperation = [...List, ...data];
						// console.log(this.khdjOperation)
						// console.log(this.khdj)
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(()=>{
						loading.close()
					},300)
				}).catch(()=>{
					loading.close()
				})
			},
			clearFun(){
				this.khdj = '全部'
			},
			// 等级优惠
			queryGradePreLsit(){
				this.tableDataGradePre =[]
				var url="/set/settb500/selectSettb500"
				// console.log(this.uobj)
				var postData = {
					// ORMTB400ID: this.uobj.ormtb400.ORMTB400ID, //一级代码ID
					// ORMTB400CA03: this.uobj.ormtb400.ORMTB400CA03, //一级客户代码
					ORMTB410ID:this.objyh.ORMTB410ID,
					SETTB99ID:this.enterpriseTwo//二级企业ID
				}
				var loading=this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						this.tableDataGradePre = res.data.data;
						// console.log(this.tableDataGradePre)
						this.tableDataGradePre.forEach((resitme) => {
							resitme.settb500List.forEach((itme) => {
								itme.djkjOld = itme.djkj;
								itme.zczkOld = itme.zczk;
								itme.zcyhOld = itme.zcyh;
							})
						})
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(()=>{
						loading.close()
					},300)
				}).catch(()=>{
					loading.close()
				})
			},
			handleSizeChange(val) {
				// 每页显示的条数
				// this.startTime = this.date[0];
				// this.endTime = this.date[1];
				this.limitMo = val;
				this.pageMo = 1;
				// this.initTableList();
			},
			handleCurrentChange(val) {
				// this.startTime = this.date[0];
				// this.endTime = this.date[1];
				this.pageMo = val;
				// this.initTableList();
			},
			queryEnterpriseTwoLsit(item){
				this.enterpriseTwoOptionList =[{
					SETTB99ID:"",
					SETTB99CA00:"全部",
				}]
				// console.log(item)
				var url="/set/settb500/selectSettb100"
				var postData = {
					// ORMTB410ID:item.ORMTB410ID,
				}
				var loading=this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						this.enterpriseTwoOptionList =[...this.enterpriseTwoOptionList,...res.data.data];
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(()=>{
						loading.close()
					},300)
				}).catch(()=>{
					loading.close()
				})
			},
			submissionGradePre(){
				var url="/set/settb500/updateSettb500List"
				var settb500List=[]
				this.tableDataGradePre.forEach((resitme) => {
					resitme.settb500List.forEach((itme) => {
						// itme.SETTB400ID = itme.SETTB400ID;
						// itme.djkjca06 = itme.djkj;
						// itme.zczkca06 = itme.zczk;
						// itme.zcyhca06 = itme.zcyh;
						settb500List.push(itme)
					})
				})
				var postData = {
					settb500List:settb500List,
				}
				var loading=this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						this.queryGradePreLsit()
						this.$message({
							message: '保存成功',
							type: 'success'
						});
						this.yhPreferentialShow = false
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(()=>{
						loading.close()
					},300)
				}).catch(()=>{
					loading.close()
				})
			},
			
			submisyhsionGradePre(){
				
				this.yhPreferentialShow = true
				
				var url="/set/settb500/confirm"
				var settb500List=[]
				this.tableDatayhGradePre = []
				this.tableDataGradePre.forEach((resitme) => {
					resitme.settb500List.forEach((itme) => {
						// itme.SETTB400ID = itme.SETTB400ID;
						// itme.djkjca06 = itme.djkj;
						// itme.zczkca06 = itme.zczk;
						// itme.zcyhca06 = itme.zcyh;
						settb500List.push(itme)
					})
				})
				var postData = {
					settb500List:settb500List,
				}
				var loading=this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						this.tableDatayhGradePre = res.data.data;
						// console.log(this.tableDatayhGradePre)
						this.tableDatayhGradePre.forEach((resitme) => {
							resitme.forEach((itme) => {
								itme.djkjOld = itme.djkj;
								itme.zczkOld = itme.zczk;
								itme.zcyhOld = itme.zcyh;
							})
						})
						// this.$message({
						// 	message: '提交成功',
						// 	type: 'success'
						// });
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(()=>{
						loading.close()
					},300)
				}).catch(()=>{
					loading.close()
				})
			},
			
			
			// 
			tableDetilsClick(item){
				// if(item.SETTB206CA00=='0201'){
				// 	this.queryPredetileLsit()
				// 	this.PreferentialDetilsShow=true
				// }else if(item.SETTB206CA00=='0202'){
					
				// }
				this.objyh = item
				this.queryGradePreLsit()
				this.queryEnterpriseTwoLsit()
				this.levelmangShow=true
			},
			// 重置
			ResetGradePre(){
				this.tableDataGradePre.forEach((resitme) => {
					resitme.settb500List.forEach((itme) => {
						itme.djkj = itme.djkjOld;
						itme.zczk = itme.zczkOld;
						itme.zcyh = itme.zcyhOld;
					})
				})
			},
			queryPreTypeLsit(){
				this.tableData =[]
				var url="/set/settb500/selectStatus"
				
				if(this.khdj == '全部'){
					this.khdj = ''
				}
				var postData = {
					// SETTB206CD01:this.uobj.ormtb400.ORMTB400CA03,
					SETTB205ID: '02', //客户名称
					ORMTB410CA00: this.cusQueryName,
					ORMTB410CA02: this.cusQueryiphone,
					ORMTB410CA06: this.khdj,
					page: this.pageMo,
					limit: this.limitMo //代码类型
					// SETTB206CA00:this.perTypeValue,
					// SETTB206CA02:this.typevalue
				}
				var loading=this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						this.tableData = res.data.data;
						this.recordCount = res.data.count;
						// this.khdj = '全部'
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(()=>{
						loading.close()
					},300)
				}).catch(()=>{
					loading.close()
				})
			},
			querySelectPreTypeLsit(){
				this.options =[{
					SETTB206CA00:"",
					SETTB206CA01:"全部",
				}]
				var url="/set/settb400/select206List"
				var postData = {
					// SETTB206CD01:this.uobj.ormtb400.ORMTB400CA03,
					SETTB205ID: '02', //客户名称
					SETTB206CA00:'',
					SETTB206CA02:''
				}
				var loading=this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						this.options =[...this.options,...res.data.data];
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(()=>{
						loading.close()
					},300)
				}).catch(()=>{
					loading.close()
				})
			},
			changeTable(row){
				var str=row.ORMTB410CB16==0?'启用':'禁用'
				this.$confirm(`此操作将${str}该条数据, 是否继续?`, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					// var url="/set/settb400/updataYhType"
					// var postData = {
					// 	SETTB206ID:row.SETTB206ID,
					// 	SETTB206CA02:row.SETTB206CA02,
					// }
					var url="/set/settb500/updateStatus"
					var postData = {
						ORMTB410ID:row.ORMTB410ID,
						ORMTB410CB16:row.ORMTB410CB16
					}
					var loading=this.$loading({
						lock: true,
						text: '请求中...',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.5)'
					});
					this.axios.post(url, postData).then(res => {
						// console.log(res)
						if (res.data.code == 200) {
							this.$message({
								message: `${str}成功`,
								type: 'success'
							});
						} else {
							this.$message({
								message: res.data.message,
								type: 'error'
							});
						}
						setTimeout(()=>{
							loading.close()
						},300)
						this.queryPreTypeLsit()
					}).catch(()=>{
						loading.close()
						this.queryPreTypeLsit()
					})
					
				}).catch(()=> {
					this.queryPreTypeLsit()
				});
			},
			Prechange(row){
				var str=row.SETTB400CA07==0?'禁用':'启用'
				this.$confirm(`此操作将${str}该条数据, 是否继续?`, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					var url="/set/settb400/updateSettb400Status"
					var postData = {
						SETTB400ID:row.SETTB400ID,
						SETTB400CA07:row.SETTB400CA07,
					}
					var loading=this.$loading({
						lock: true,
						text: '请求中...',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.5)'
					});
					this.axios.post(url, postData).then(res => {
						// console.log(res)
						if (res.data.code == 200) {
							this.$message({
								message: `${str}成功`,
								type: 'success'
							});
						} else {
							this.$message({
								message: res.data.message,
								type: 'error'
							});
						}
						setTimeout(()=>{
							loading.close()
						},300)
						this.queryPredetileLsit()
					}).catch(()=>{
						loading.close()
						this.queryPredetileLsit()
					})
					
				}).catch(()=> {
					this.queryPredetileLsit()
				});
			},
			queryPredetileLsit(){
				this.PreferentialDetilsData =[]
				var url="/set/settb400/selectSettb400List"
				// console.log(this.uobj)
				return;
				var postData = {
					ORMTB400ID:this.uobj.ormtb400.ORMTB400ID,
				}
				var loading=this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						this.PreferentialDetilsData =res.data.data
						this.PreferentialDetilsData.forEach(item=>{
							item.money=item.SETTB400CA00+'—'+item.SETTB400CA01
						})
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(()=>{
						loading.close()
					},300)
				}).catch(()=>{
					loading.close()
				})
			},
			insertStatInpt(){
				this.insertStatMoney = this.insertStatMoney.replace(/[^\d]/g, ""); //清除“数字”和“.”以外的字符
				if (this.insertStatMoney.indexOf(".") < 0 && this.insertStatMoney != "") { //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
					this.insertStatMoney = parseFloat(this.insertStatMoney);
				}
				this.$refs.insertStatMoney.value = this.insertStatMoney
			},
			insertEndInpt(){
				this.insertEndMoney = this.insertEndMoney.replace(/[^\d]/g, ""); //清除“数字”和“.”以外的字符
				if (this.insertEndMoney.indexOf(".") < 0 && this.insertEndMoney != "") { //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
					this.insertEndMoney = parseFloat(this.insertEndMoney);
				}
				this.$refs.insertEndMoney.value = this.insertEndMoney
			},
			undateClick(row){
				var str=JSON.stringify(row)
				this.upMoneyObj=JSON.parse(str)
				this.updateShow=true
				this.updateStatMoney=this.upMoneyObj.SETTB400CA00
				this.updateEndMoney=this.upMoneyObj.SETTB400CA01
			},
			insertserve(){
				if(this.insertStatMoney<=0&&this.insertEndMoney<=0) return this.$message.error('请设置有效金额')
				if(this.insertStatMoney>this.insertEndMoney) return this.$message.error('开始金额不可大于结束金额')
				if(this.insertStatMoney>this.insertEndMoney) return this.$message.error('结束金额不可小于开始金额')
				var url="/set/settb400/insertSettb400"
				var postData = {
					ORMTB400ID:this.uobj.ormtb400.ORMTB400ID,
					SETTB400CA00:this.insertStatMoney,
					SETTB400CA01:this.insertEndMoney,
				}
				var loading=this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						this.$message({
							message: `新增成功`,
							type: 'success'
						});
						this.insertShow=false
						this.queryPredetileLsit()
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(()=>{
						loading.close()
					},300)
					this.queryPreTypeLsit()
				}).catch(()=>{
					loading.close()
					this.queryPreTypeLsit()
				})
			},
			updateServe(){
				if(this.updateStatMoney<=0&&this.updateEndMoney<=0) return this.$message.error('请设置有效金额')
				if(this.updateStatMoney>this.updateEndMoney) return this.$message.error('开始金额不可大于结束金额')
				if(this.updateStatMoney>this.updateEndMoney) return this.$message.error('结束金额不可小于开始金额')
				var url="/set/settb400/updateSettb400"
				var postData = {
					ORMTB400ID:this.uobj.ormtb400.ORMTB400ID,
					SETTB400ID:this.upMoneyObj.SETTB400ID,
					SETTB400CA00:this.updateStatMoney,
					SETTB400CA01:this.updateEndMoney,
					SETTB400CA07:this.upMoneyObj.SETTB400CA07,
				}
				var loading=this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						this.$message({
							message: `修改成功`,
							type: 'success'
						});
						this.updateShow=false
						this.queryPredetileLsit()
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(()=>{
						loading.close()
					},300)
					this.queryPreTypeLsit()
				}).catch(()=>{
					loading.close()
					this.queryPreTypeLsit()
				})
			},
			updateStatInpt(){
				this.updateStatMoney = this.updateStatMoney.replace(/[^\d]/g, ""); //清除“数字”和“.”以外的字符
				if (this.updateStatMoney.indexOf(".") < 0 && this.updateStatMoney != "") { //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
					this.updateStatMoney = parseFloat(this.updateStatMoney);
				}
				this.$refs.updateStatMoney.value = this.updateStatMoney
			},
			updateEndInpt(){
				this.updateEndMoney = this.updateEndMoney.replace(/[^\d]/g, ""); //清除“数字”和“.”以外的字符
				if (this.updateEndMoney.indexOf(".") < 0 && this.updateEndMoney != "") { //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
					this.updateEndMoney = parseFloat(this.updateEndMoney);
				}
				this.$refs.updateEndMoney.value = this.updateEndMoney
			},
			erpPreferentialQuery(){
				this.erpPreferentialData =[]
				var url="/set/settb400/selectPageList"
				var postData = {
					SETTB400ID:this.erpreducedObj.SETTB400ID,
					ORMTB400ID:this.uobj.ormtb400.ORMTB400ID,
					page:this.pageMo,
					limit:this.limitMo,
				}
				var loading=this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						this.erpPreferentialData =res.data.data
						this.pagingPageMo =res.data.count
						this.erpPreferentialData.forEach(item=>{
							item.money=item.SETTB400CA00+'—'+item.SETTB400CA01
							item.OldSETTB401CA00=item.SETTB401CA00
						})
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(()=>{
						loading.close()
					},300)
				}).catch(()=>{
					loading.close()
				})
			},
			erpPreferentialServe(){
				// console.log(this.upPerObj)
				var settb401List=[]
				this.erpPreferentialData.forEach(item=>{
					if(item.OldSETTB401CA00!=item.SETTB401CA00){
						settb401List.push({
							SETTB400ID:item.SETTB400ID,
							SETTB99ID:item.SETTB99ID,
							SETTB401CA00:item.SETTB401CA00+'',
							SETTB401CA01:this.upPerObj.SETTB206CA00,
							SETTB401ID:item.SETTB401ID
						})
					}
				})
				if(settb401List.length<=0) return this.$message.error('没有需要设置的优惠')
				var url="/set/settb400/insertSettb401"
				var postData = {
					settb401List:settb401List,
				}
				var loading=this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						this.$message({
							message: `设置成功`,
							type: 'success'
						});
						this.erpPreferentialQuery()
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(()=>{
						loading.close()
					},300)
				}).catch(()=>{
					loading.close()
				})
			},
			handleSizeChange(val){
				this.limitMo=val;
				this.pageMo=1;
				this.erpPreferentialQuery();
			},
			handleCurrentChange(val){
				this.pageMo=val;
				this.erpPreferentialQuery();
			},
		}
	};
</script>

<style scoped>
	.levelmang-title{
		display: flex;
		color: #333;
		text-align: center;
		margin-bottom: 20px;
		
	}
	.levelmang-title div{
		padding: 10px 20px;
		background-color: #e3e3e3;
	}
	.levelmang-title .levelmang-title-active{
		background-color: #199FFF;
		color: #FFF;
	}
	.levelmang-table{
		border: 1px solid #e3e3e3;
	}
	.levelmang-table >li{
		display: flex;
	}
	.levelmang-table-head{
		text-align: center;
		background-color: #30A8FF;
		color: #FFF;
	}
	.levelmang-table-head>div{
		height: 50px;
		line-height: 50px;
		border-left: 1px solid #e3e3e3;
		box-sizing: border-box;
		overflow: hidden;
	}
	.levelmang-table-head>div:first-child{
		border: none;
	}
	.levelmang-table-CQ{
		flex: 1;
		position: relative;
		padding: 5px 10px;
	}
	.levelmang-table-CQ-list{
		border-bottom: 1px solid #e3e3e3;
	}
	.levelmang-table-JB{
		width: 100px;
	}
	.levelmang-table-KJ,
	.levelmang-table-ZK,
	.levelmang-table-YH{
		width: 240px;
	}
	.levelmang-table-ZK input,
	.levelmang-table-YH input{
		text-align: center;
	}
	.levelmang-table-li{
		text-align: center;
	}
	.levelmang-table-li-tab-li{
		
		border-bottom: 1px solid #e3e3e3;
	}
	.levelmang-table-li-tab-li:last-child{
		/* border: none; */
	}
	.levelmang-table-li-tab-li>div{
		border-left: 1px solid #e3e3e3;
		padding: 0 10px;
		box-sizing: border-box;
		height: 50px;
		line-height: 50px;
		vertical-align: top;
		overflow: hidden;
	}
	.levelmang-table-li-tab-li>div>input{
		width: 100px;
		border: 1px solid #e3e3e3;
		height: 35px;
		line-height: 35px;
		border-radius: 5px;
		margin-right: 10px;
	}
	.levelmang-table-CQ>div{
		position: absolute;
		left: 50%;
		top: 50%;
		width: 100%;
		transform: translate(-50%,-50%);
	}
	.levelmang-table-li-tab-li{
		display: flex;
	}
	.salesPreferentialDig-li{
		display: flex;
	}
	.salesPreferentialDig-li-text{
		padding: 0 20px;
		height: 50px;
		line-height: 50px;
	}
	.salesPreferentialDig-li-ipt{
		display: flex;
	}
	.salesPreferentialDig-li-ipt input{
		width: 200px;
		height: 35px;
		line-height: 35px;
		font-size: 18px;
		color: #333;
	}
	.salesPreferentialDig-li-ipt div{
		height: 35px;
		padding: 0 10px;
	}
	.salesPreferentialDig-li-ipt div span{
		display: inline-block;
		width: 30px;
		height: 1px;
		background-color: #999;
	}
	.salesPreferentialDig-btn {
		text-align: center;
		margin: 30px 0 20px 0;
	}
	.systemCorporateAccount {
		background-color: #f3f3f3;
	}

	.test111:active {
		background-color: red !important;
	}

	.systemCorporateAccount-display,
	.systemCorporateAccount-wuliao-input {
		display: flex;
		flex-direction: row;
		align-items: center !important;
	}

	.systemCorporateAccount-optionSty {
		width: 140px;
		margin-right: 30px;
	}

	.systemCorporateAccount-wuliao-input>input {
		height: 40px;
		box-sizing: border-box;
		border: 1px solid #dcdfe6;
		border-radius: 5px;
		padding-left: 5px;
	}
	.systemCorporateAccount-dialog{
		padding: 0 20px;
	}
	.systemCorporateAccount-dialog-li{
		display: flex;
		box-sizing: border-box;
	}
	.systemCorporateAccount-dialog-li+.systemCorporateAccount-dialog-li{
		margin-top: 20px;
	}
	.SCADL-text{
		height: 30px;
		line-height: 30px;
		flex:.35;
		font-size: 18px;
		color: #333;
	}
	.SCADL-text span{
		color: red;
	}
	.SCADL-input{
		flex:1;
		box-sizing: border-box;
	}
	.SCADL-input input{
		height: 30px;
		line-height: 30px;
		width: 99.9%;
		padding-left: 10px;
		border:1px solid #999;
		color: #333;
		font-size: 18px;
		border-radius: 5px;
		box-sizing: border-box;
	}
	.SCADL-input .el-select{
		width: 99.9%;
	}
	.SCADL-input .el-input__inner{
		height: 30px;
		line-height: 30px;
	}
	.systemCorporateAccount-dialog-btn{
		text-align: center;
		margin-top: 40px;
	}
	.systemCorporateAccount-dialog-li
	.CADL-binding-input{
		border: none;
		outline: none;
	}
	.SCADL-btn input{
		display: inline-block;
		width: 65%;
	}
	.SCADL-btn .el-button{
		height: 30px;
		line-height: 30px;
		padding: 0 20px;
	}
	.systemCorporateAccount-dialog-operation-btn{
		margin-top: 20px;
	}
	.systemCorporateAccount-dialog .pulbic_oparetionBlock{
		padding-left: 0;
		padding-right: 0;
	}
	.systemCorporateAccount-dialog-operation-btn .el-button:last-child{
		background-color: #ffaa00;
	}
</style>


